import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CursorService {
  public setGlobalCursor(cursor: string) {
    document.body.style.cursor = cursor;
    document.body.classList.add('global-cursor');
  }

  public clearGlobalCursor() {
    document.body.style.cursor = '';
    document.body.classList.remove('global-cursor');
  }
}
